import { Injectable } from "@angular/core";
import { CleanFilePathService } from "../clean-file/clean-file-path.service";

@Injectable()
export class StdAttrsService {
  constructor(private cleanFilePathService: CleanFilePathService) {}

  public getAttrs() {
    // key: Unique identifier for the attribute
    // heading: Used in the attributes list on the aggregations tab
    // searchLabel: Used as the label for search pills
    // suggestionFormat: Function used to format the value for the search dropdown
    //   Goab returns attributes in this format:
    //   {
    //     attribute:
    //       groupId: 123,
    //       key: "context.remoteCountry",
    //       keyId: '5678',
    //       projectId: 99,
    //       value: {
    //         remoteCountry: "United States",
    //         remoteCountryCode: "US"
    //       },
    //       valueId: '7890'
    //   }
    // The suggestionFormat could return `remoteCountry`, `remoteCountryCode`, or
    // a combination of the two depending on what you want to display to the user.
    const stdAttrs = [
      {
        key: "errors.0.message",
        heading: "Messages",
        searchLabel: "Message",
        suggestionFormat(value: any) {
          return value.message;
        },
      },
      {
        key: "context.messageParams",
        heading: "Message params",
        searchLabel: "Message param",
        suggestionFormat(value: any) {
          return value;
        },
      },
      {
        key: "context.user",
        heading: "Users",
        searchLabel: "User",
        suggestionFormat(value: any) {
          return value.email;
        },
      },
      {
        key: "context.browserName",
        heading: "Browsers",
        searchLabel: "Browser",
        suggestionFormat(value: any) {
          return value.name;
        },
      },
      {
        key: "context.browser",
        heading: "Browser versions",
        searchLabel: "Browser version",
        suggestionFormat(value: any) {
          return `${value.name} ${value.version}`;
        },
      },
      {
        key: "context.browserEngine",
        heading: "Browser engines",
        searchLabel: "Browser engine",
        suggestionFormat(value: any) {
          return `${value.name} ${value.version}`;
        },
      },
      {
        key: "context.browserPlatform",
        heading: "Browser platforms",
        searchLabel: "Browser platform",
        suggestionFormat(value: any) {
          return `${value.os} ${value.platform}`;
        },
      },
      {
        key: "context.url",
        heading: "URLs",
        searchLabel: "URL",
        suggestionFormat(value: any) {
          return value.url;
        },
      },
      {
        key: "context.hostname",
        heading: "Server hostnames",
        searchLabel: "Hostname",
        suggestionFormat(value: any) {
          return value.hostname;
        },
      },
      {
        key: "context.userAddr",
        heading: "User addresses",
        searchLabel: "User address",
        suggestionFormat(value: any) {
          return value.userAddr;
        },
      },
      {
        key: "context.userCountry",
        heading: "User countries",
        searchLabel: "User country",
        suggestionFormat(value: any) {
          return value.userCountry;
        },
      },
      {
        key: "context.remoteAddr",
        heading: "Remote addresses",
        searchLabel: "RemoteAddr",
        suggestionFormat(value: any) {
          return value.remoteAddr;
        },
      },
      {
        key: "context.remoteCountry",
        heading: "Remote countries",
        searchLabel: "Remote country",
        suggestionFormat(value: any) {
          return value.remoteCountry;
        },
      },
      {
        key: "context.version",
        heading: "Versions",
        searchLabel: "Version",
        suggestionFormat(value: any) {
          return value.version;
        },
      },
      {
        key: "context.component",
        heading: "Components",
        searchLabel: "Component",
        suggestionFormat(value: any) {
          return value.component;
        },
      },
      {
        key: "context.action",
        heading: "Actions",
        searchLabel: "Action",
        suggestionFormat(value: any) {
          return value.action;
        },
      },
      {
        key: "context.environment",
        heading: "Environments",
        searchLabel: "Environment",
        suggestionFormat(value: any) {
          return value.environment || "unknown";
        },
      },
      {
        key: "errors.0.file",
        heading: "Files",
        searchLabel: "File",
        suggestionFormat: (value: any) => {
          return this.cleanFilePathService.clean(value.file);
        },
      },
      {
        key: "errors.0.function",
        heading: "Functions",
        searchLabel: "Function",
        suggestionFormat(value: any) {
          return value.function;
        },
      },
      {
        key: "context.httpMethod",
        heading: "HTTP methods",
        searchLabel: "HTTP method",
        suggestionFormat(value: any) {
          return value.httpMethod;
        },
      },
      {
        key: "context.route",
        heading: "Routes",
        searchLabel: "Route",
        suggestionFormat(value: any) {
          return value.route;
        },
      },
    ];

    return stdAttrs as any[];
  }
}
